import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectEditFormSubmissionViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
ProjectEditFormSubmissionViewTopBar.displayName = "ProjectEditFormSubmissionViewTopBar"
